import { Link } from 'react-router-dom';
import { classNames } from '@/lib/utils';

interface Props {
  /** Id del propietario. Puede faltar en registros antiguos. */
  ownerId?: string;
  /** Nombre a mostrar. Suele ser la foto fija guardada en el documento, no el
      nombre actual del propietario: es el que salió en el PDF y el que se
      espera reconocer aquí. */
  name: string;
  /** Si el propietario sigue existiendo en el CRM. Cuando es false se pinta
      texto plano: la ficha de un propietario borrado no da 404, se queda con el
      spinner girando para siempre (OwnerDetailPage), así que un enlace muerto
      es peor que no tener enlace. */
  exists: boolean;
  /** Clases del texto (truncate, font-semibold…), que cambian en cada sitio. */
  className?: string;
}

export default function OwnerLink({ ownerId, name, exists, className }: Props) {
  if (!ownerId || !exists) {
    return <span className={className}>{name}</span>;
  }
  return (
    <Link
      to={`/owners/${ownerId}`}
      title={`Ver ficha de ${name}`}
      className={classNames('hover:underline', className)}
    >
      {name}
    </Link>
  );
}
